import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import CategoryPage from './pages/CategoryPage';
import Professional from './pages/Professional';
import Publicite from './pages/Publicite';
import About from './pages/About';
import Contact from './pages/Contact';
import Dashboard from './pages/Dashboard';
import Admin from './pages/Admin';
import AdminEditPage from './pages/AdminEditPage';

const App = () => {
  return (
    <div className="min-h-screen bg-background text-text">
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<Services />} />
        <Route path="/categories/:slug" element={<CategoryPage />} />
        <Route path="/professional" element={<Professional />} />
        <Route path="/page" element={<Publicite />} />
        <Route path="/page/:publiciteId" element={<Publicite usePubliciteId={true} />} />
        <Route path="/page/ville/:ville/:categorie" element={<Publicite />} />
        <Route path="/page/departement/:departement/:categorie" element={<Publicite />} />
        <Route path="/page/ville-id/:villeId/:categorieId" element={<Publicite useIds={true} />} />
        <Route path="/page/departement-id/:departementId/:categorieId" element={<Publicite useIds={true} />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/:pageSlug" element={<AdminEditPage />} />
      </Routes>
    </div>
  );
};

export default App;
